import { render, staticRenderFns } from "./Rotacion.vue?vue&type=template&id=706461a0&scoped=true&"
import script from "./Rotacion.vue?vue&type=script&lang=js&"
export * from "./Rotacion.vue?vue&type=script&lang=js&"
import style0 from "./Rotacion.vue?vue&type=style&index=0&id=706461a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706461a0",
  null
  
)

export default component.exports